import React from 'react';

const AdditionalItems = ({visible, handleFormChange, contactInfo, disclaimers, logos}) =>{

    if (visible){
        return (
            <div className="medium-8 column additional-items">
                <fieldset>
                    <legend>Optional Items</legend>
                    <p>Not all of these options are used in each signature.</p>                   

                    <label>
                        Disclaimer
                        <select 
                            name="disclaimer"
                            onChange={handleFormChange}
                            value={contactInfo.disclaimer}>
                            <option value="No">No</option>

                            {disclaimers.map(disclaimer => 
                                <option value={disclaimer.id} key={disclaimer.id}>
                                    {disclaimer.name}
                                </option>
                            )}

                        </select>
                    </label>

                    <label>
                        Department Logo
                        <span>Used for <em>Signature with Logo</em></span>
                        <select 
                            name="logo"
                            onChange={handleFormChange}
                            value={contactInfo.logo}>
                            <option value="No">None</option>

                            {logos.map(logo => 
                                <option value={logo.id} key={logo.id}>
                                    {logo.name}
                                </option>
                            )}

                        </select>
                    </label>

                    <label>
                        Relative path to your photo:
                        <span>Used for <em>Signature with Photo</em></span>
                        <input name="photo" type="text" 
							onChange={handleFormChange}
							value={contactInfo.photo} />
                    </label>

                </fieldset>
            </div>
        )
    }else{
        return(<div></div>)
    }
}

export default AdditionalItems;